import React, { useState } from 'react';
import FlexibleDataFetcher from '../components/flexibileDataFetcher';
import DashboardCard from '../components/adminStartupDetails/dashboardCard';

export default function Dashboard() {
  const [data, setData] = useState({});

  const handleSuccess = (fetchedData) => {
    setData(fetchedData);
    console.log("data", fetchedData);
  };

  const handleError = (error) => {
    console.error('Failed to fetch data:', error);
  };

  const readableLabels = {
    countInnovations: "Standard Startup",
    countInnovationsForChat: "Innovations for Chat",
    countInnovationsViewed: "Innovations Viewed",
    countActiveUsers: "Active Users",
    countChatsUsers: "User Chats",
    countChatsAi: "AI Chats",
    countAdvisories: "Advisories",
    countAdvisoryUsers: "Advisory Users",
    countSurveysSent: "Surveys Sent",
    countSurveysCompleted: "Surveys Completed",
    activity: "Activity"
  };

  return (
    <div className='flex flex-col gap-5 p-5 h-full'>
      <FlexibleDataFetcher 
        endpoint='/dashboard' 
        onSuccess={handleSuccess} 
        onError={handleError} 
      />

      {/* Render cards in rows of 2 */}
      <div className="flex flex-wrap gap-5">
        {Object.entries(data).map(([key, value]) => (
          <div key={key} className="w-[calc(50%-10px)]">
            <DashboardCard title={readableLabels[key] || key} value={value} />
          </div>
        ))}
      </div>
    </div>
  );
}
